<template lang="pug">
#app.am-body
  template
    link(rel="stylesheet", :href="getStyleSheet(theme)")
    loading-bar(:loadingBarValue="loadingBarValue")
    headerbar(:user="user", :location="location", v-if="showHeader")
    navbar(v-if="showHeader")
    router-view(@setLoadingBar="setLoadingBar")
    heap(v-if="showHeap")
</template>

<script>
import LoadingBar from '@/components/LoadingBar'
import Headerbar from '@/components/Headerbar'
import Navbar from '@/components/Navbar.vue'
import { mapState, mapActions } from 'vuex'
import config from '@/config/global.config'
import Heap from '@/components/Heap.vue'

export default {
  name: 'App',

  components: {
    LoadingBar,
    Headerbar,
    Navbar,
    Heap
  },

  data () {
    return {
      loadingBarValue: 0
    }
  },

  computed: {
    ...mapState('auth', [
      'user',
      'location'
    ]),
    theme () {
      let themesId = (this.$store.state.auth.config.themesId) ? this.$store.state.auth.config.themesId : 1
      return '/themes/Theme' + ('00' + themesId).slice(-3) + (themesId === 1 ? 'vue' : '') + '.css'
    },
    showHeader () {
      return this.$route.query.hideHeader !== 'true'
    },
    showHeap () {
      return config.heapEnabled()
    }
  },

  methods: {
    ...mapActions('auth', [
      'checkLogin'
    ]),
    setLoadingBar (value) {
      this.loadingBarValue = value
      let self = this
      if (value === 100) {
        setTimeout(function () {
          self.loadingBarValue = 0
        }, 500)
      }
    },
    getStyleSheet (url) {
      return config.applicationUrl(url)
    }
  },

  beforeMount () {
    if (config.enforceLogin()) {
      this.checkLogin().then(() => {
        console.log('Login Confirmed')
      }).catch(err => {
        console.error(err)
        // window.location.href = config.appUrl
        console.log(config.appUrl)
      })
    }

    this.$store.dispatch('office/load')
  }
}
</script>

<style lang="sass">
#app
  height: 100%

.is-relative
  position: relative

.monospace
  font-family: monospace

.truncate
  max-width: 100px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.tag
  position: relative
  &:before
    content: ""
    position: absolute
    top: 0
    right: 0
    width: 0
    height: 0
    display: block
    border-left: 15px solid transparent
    border-bottom: 15px solid transparent

  &.tag-red:before
    border-top: 15px solid #f00

  &.tag-blue:before
    border-top: 15px solid #428bca

  &.tag-green:before
    border-top: 15px solid #088c07
th.shrink
  width: 0.1%
</style>
